<script>
    import {createEventDispatcher} from 'svelte';
    import {replace} from 'svelte-spa-router';
    import {getObj, saveObj, deleteObj, getFields} from '../lib/data.js'
    import { notifier } from '@beyonk/svelte-notifications'

    import Loader from '../Utilities/Loader.svelte';
    import Form from '../Forms/Form.svelte';

    const dispatch = createEventDispatcher();

    export let params;
    export let object_type;
    export let returnURL = "";

    let item;

    let form_errors = {};

    $: getItem(params.id)

    function titleCase(s) {
        return s.replace(/^\w/, c => c.toUpperCase());
    }

    async function getItem(id) {
        try {
            item = await getObj(object_type, id);
        } catch (response) {
            if (response.status == 404) {
                notifier.warning(`${titleCase(object_type)} Not Found`)
                if (returnURL){
                    replace(returnURL)
                } else {
                    dispatch("notFound");
                }
            }
        }
    }

    async function saveItem() {
        try {
            item = await saveObj(object_type, item);
            notifier.success(`${titleCase(object_type)} Saved`)
            dispatch("save");
        } catch (errors) {
            console.log(errors);
            form_errors = errors
        }
    }

    async function deleteItem() {
        try {
            await deleteObj(object_type, item);
            notifier.success(`${titleCase(object_type)} Deleted`);
            dispatch("delete");
        } catch (error) {
            console.log(error);
        }
    }

    let fields = getFields(object_type)
</script>

<Loader obj={item}>
    <h1 class="title">{#if item.id}Edit{:else}Create{/if} {titleCase(object_type)}</h1>
    <hr>
    <Form on:submit={saveItem} on:delete={deleteItem} {fields} bind:data={item} errors={form_errors} />
</Loader>